import { Component, OnInit, ViewChild, ElementRef, Renderer2, Input, AfterContentInit, Output, EventEmitter } from '@angular/core';
import { ProjectData } from 'src/app/entities/project-data.entity';
import { Router, ActivatedRoute } from '@angular/router';
import interact from 'interactjs';
import { ProjectDataPuerta } from 'src/app/entities/project-data-puerta.entity';
import { ProjectDataPerimetro } from '../../entities/project-data-perimetro.entity';
import { Utils } from '../../utils.module';
import { BuilderHistorialService } from '../builder-historial.service';
import { UtilsBuilder } from '../utils-builder';
import { ProjectDataScheme } from 'src/app/entities/project-data-scheme';
import { ParseProjectVersion } from 'src/app/utils/parse-project-version';
import { CanvasRendererComponent } from '../canvas-renderer/canvas-renderer.component';

@Component({
	selector: 'app-scheme2',
	templateUrl: './scheme2.component.html',
	styleUrls: ['./scheme2.component.css', './scheme2.component.scss']
})
export class Scheme2Component implements OnInit, AfterContentInit {

	//#region #################### Constantes.
	public readonly CURSOR = {
		POINTER: 0,
		ERASE: 1,
		DRAW: 2
	};

	private SCALES = [
		{
			currentScale: 1000,
			incrementZoom: 0.1,
			maxZoom: 3,
			minZoom: 0.2,
			ajustMetersOrientationX: 1000,
			ajustMetersOrientationY: -1000
		},
		{
			currentScale: 100,
			incrementZoom: 0.1,
			maxZoom: 3,
			minZoom: 0.2,
			ajustMetersOrientationX: 100,
			ajustMetersOrientationY: -100
		},
		{
			currentScale: 10,
			incrementZoom: 0.1,
			maxZoom: 3,
			minZoom: 0.2,
			ajustMetersOrientationX: 10,
			ajustMetersOrientationY: -10
		}
	];

	// Pruebas para cambiar la escala para conseguir planos con mayor tamaño.
	private __testeo = 0;
	private scale = this.SCALES[this.__testeo];
	// Usados para pasar a metros y reorientación de la Y.
	//private currentScale = this.SCALES[this.__testeo].currentScale; // 1000; // 1000 / 100 / 10
	//private AJUSTE_METROS_ORIENTACION_X = this.currentScale;
	//private AJUSTE_METROS_ORIENTACION_Y = -this.currentScale;
	// Incremento del z oom. Actualmente es una constante ya que el editor no contempla su modificación.
	//private INCREMENT_Z OOM = this.SCALES[this.__testeo].incrementZ oom; //0.1;
	//private MAX_Z OOM = this.SCALES[this.__testeo].max Z oom; //3;			// Máximo z oom permitido. 3
	//private MIN_Z OOM = this.SCALES[this.__testeo].min Z oom; //0.5;		// Mínimo z oom permitido. 0.5

	// SVG alto y largo de la grid.
	public readonly SVGWidth = 20000;
	public readonly SVGHeight = 20000;

	// Usado para ajustar el perímetro al centro de la grid.
	private readonly AJUSTE_GRID = this.SVGWidth / 2;

	public readonly MAX_ALTURA_ESCALON = 3;

	// Estados del editor.
	// Toolbar = mano, se puede mover la grid y seleccionar un perímetro.
	private ESTADO_DRAG = 0;
	// Toolbar = lápiz, está editando un nuevo perímetro, no puede seleccionar otros.
	private ESTADO_NEW = 1;
	// Toolbar = ?, hay un perímetro seleccionado.
	private ESTADO_SELECT = 2;
	// Toolbar = puerta, debe existir un perímetro seleccionado (ESTADO_SELECT), coloca una puerta.
	private ESTADO_DOOR = 3;
	// Toolbar = peldaño, debe existir un perímetro seleccionado (ESTADO_SELECT), coloca una elevación.
	private ESTADO_ELEVATION = 4;
	// Toolbar = elimina un perímetro.
	private ESTADO_ERASE = 5;
	//#endregion

	// private x:any = sessionStorage.getItem('coordenadas') ? JSON.parse(sessionStorage.getItem('coordenadas')).x : -((20000 / 2) - (window.innerWidth / 2));
	// private y:any = sessionStorage.getItem('coordenadas') ? JSON.parse(sessionStorage.getItem('coordenadas')).y :-((20000 / 2) - (window.innerHeight / 2));



	//#region SVG
	public static readonly NOT_PERIMETER = -1;

	// Escala actual, se usa para multiples calculos.
	public scaleRange = 1;
	public unit = 1;		// Unidad de la escala actual (1/scaleRange).

	public SVGSelector = 'hidden'; // Selector 'visible'.
	// Línea Grid de división por 10.
	public SVGLineGrid10 = 1; // Escala a 1.
	public SVGLineGrid = 0.5; // Escala a 1.
	// Línea del Path simple.
	public SVGLinePath = 3; // Escala a 1.
	public SVGStrongLinePath = 14; // Escala a 1.
	// Screenshot
	public SVGStrongLine = 'black'; // Escala a 1.
	public SVGStrongWidth = 5; // Escala a 1.
	public SVGwidth = 0;
	public SVGheight = 0;
	// Postes o puntos.
	public SVGCirclePoint = 1; // Escala a 1.
	public SVGCircleRadio = 7; // Escala a 1.
	public SVGBreakRadio = 5; // Escala a 1.
	public SVGHaloRadio = 12; // Escala a 1.
	// Textos
	public SVGText = 12; // Escala a 1.
	public SVGTextSeparation = 12; // Escala a 1.
	// Puertas.
	public SVGDoor = "24px"; // Escala a 1.
	public SVGDoorX = 12;
	public SVGDoorY = 24;

	//Escalones
/* 	public SVGEscalon = "24px";
	public SVGEscalonX = 12;
	public SVGEscalonY = 24; */

	// Indice del perímetro que ha sido seleccionado.
	// Ocurre cuando se pasa de ESTADO_DRAG a ESTADO_SELECT
	public INDEXPerimeterSelected = Scheme2Component.NOT_PERIMETER;

	// Nuevo perímetro (solo en ESTADO_NEW).
	public INDEXPerimeterNew = Scheme2Component.NOT_PERIMETER;

	// Indice del perímetro sobre el que se pasa el ratón.
	public INDEXPerimeterOver = Scheme2Component.NOT_PERIMETER;

	// Elevación seleccionada.
	public INDEXElevationSelected = Scheme2Component.NOT_PERIMETER;

	//Recoger valores de la grilla
	public valoresGrilla:any;
	public gridPosition:boolean = true; 
	//#endregion

	//#region #################### @ViewChildren's
	// Elemento SVG.
	@ViewChild('PlaneSVG', { static: true }) PlaneSVG: ElementRef;

	//#region #################### @Input's
	// Proyecto en curso.
	@Input() projectData: ProjectData;
	@Input('posicion') posicion:any;
	//#endregion

	//#region #################### @Output's
	// Petición de cambio de modo 2D a 3D y viceversa.
	@Output() change3Dto2D: EventEmitter<any> = new EventEmitter();
	// Petición de actualización del toolbar.
	@Output() actualizarToolBar: EventEmitter<any> = new EventEmitter();
	// Aviso de que se a seleccionado un perímetro.
	@Output() selectPerimeter: EventEmitter<any> = new EventEmitter();
	// Aviso de cambio de zoom.
	@Output() zoomChange: EventEmitter<any> = new EventEmitter();
	// Aviso de cambio de longitud del perímetro.
	@Output() changeLengthPerimeters: EventEmitter<any> = new EventEmitter();
	@Output() mueveGrid: EventEmitter<any> = new EventEmitter();
	//#endregion
	
	

	//#region #################### Parámetros globales.
	public cursorGoma = false;			// Si es true cursor es una goma de borrar.			MVC acción.
	public cursorDraw = false;			// Si es true cursor es una cruz.					MVC acción.

	// ##### DRAG & DROP
	public dragAndDrop = false;			// indica si está arrastrando.
	public activateCruceta = true; //false;		//  Indica si debe activarse la cruceta al seleccionar un poste en tablets.
	public elementWithCrucetaId = null;	//El id del elemento al que queremos activar la cruceta.
	// ##### DRAG & DROP

	//#region #################### Parámetros locales.
	// En estado nuevo perímetro marca la distancia entre el cursor y el último punto dibujado.
	private HTMLNumberNew;

	// Ajuste actual del zoom.
	private adjustZoom = 0;

	// Intervalo de tiempo para evitar clicks del mouse consecutivos.
	private intervalMouseClick = 0;

	// Actual estado del editor.
	private state = this.ESTADO_DRAG;

	// Total longitud perímetros.
	private totalLengthPerimeters = 0;
	private totalLengthPerimetersStr = '0,00';

	// Dependiendo del navegar, para Chrome -> 'mousewheel', para FireFox -> 'wheel'.
	private navigatorScroll = 'mousewheel';		// Por defecto para Chrome.

	// Perímetro seleccionado.
	private perimeterSelected: ProjectDataPerimetro;

	// Si es true indica que es un PC en caso contrario es una tablet o dispositivo móvil.
	public isPC = true;

	// Usados para almacenar el toque de la pantalla.
	private touchX = 0;
	private touchY = 0;

	// ##### DRAG & DROP
	private objPressed: any;			// objeto que se ha tocado.
	private breaking = false;			// Está en fase de división de tramo.
	private objMoved = false;			// Indica si en el arrastre ha habido movimiento.
	private activateCrucetaDelay = 80;	// Tiempo que se debe esperar para activar la cruceta.
	private touchstart = false;			// SWe inicia toque.
	// ##### DRAG & DROP

	// Clase encargada de calcular el presupuesto.
	private utilsBuilder: UtilsBuilder;

	//#endregion

	// #################### CODE
	constructor( private router: Router,
				 private route:ActivatedRoute,
				 public historialService: BuilderHistorialService,
				 private renderer: Renderer2 ) 
	{		
		this.utilsBuilder = new UtilsBuilder();
	}

	//#region #################### Eventos propios de angular.
	// Solo se ejecuta una vez.
	ngOnInit() {

		// Actualizar el scroll dependiendo del navegador.
		if (window.navigator.userAgent.indexOf('Firefox') > -1) {
			this.navigatorScroll = 'wheel';
		}

		// Comprobar si es un PC o un dispositivo móvil.
		if (window.navigator.userAgent === ''
			|| window.navigator.userAgent.match(/Android/i)
			|| window.navigator.userAgent.match(/iPhone|iPad|iPod/i)
			|| (window.navigator.userAgent.match(/Macintosh/i) && ('ontouchstart' in window))) {
			this.isPC = false;
		}
		//this.isPC = false;
		// Comprobar si tiene proyecto.
		if (!this.projectData || this.projectData.nombre === '') {
			// Obtener el proyecto del localStorage.
			const tempData = JSON.parse(localStorage.getItem(Utils.CURRENT_PROJECT));

			// Si no hay proyecto enviar al hold.
			//if (!tempData || !tempData.userID) this.router.navigate([' /hold']);
			if (!tempData || !tempData.userID) this.router.navigate(['/satelite']);
		}

		this.setProjectData(this.projectData);
	}

	public updateFromParent(whereYouFrom: string) {
		this.projectData = JSON.parse(localStorage.getItem(Utils.CURRENT_PROJECT));
		//console.log('updateFromParent Estado::' + this.projectData.estado);
		if (this.projectData.estado !== 0) {
			this.INDEXPerimeterSelected = Scheme2Component.NOT_PERIMETER;
			this.perimeterSelected = undefined;
		}

		this.unit = 1;
		this.adjustZoom = this.scale.incrementZoom * (this.SVGWidth / 2);
		this.onUsuarioSeleccionado('DRAG');
		this.activateCursor(this.CURSOR.POINTER);
		this.setDragMode();

		this.scaleRange = 1;		

		if (!this.projectData.scheme) this.projectData.scheme = new ProjectDataScheme();

		// Calculamos el centro de los dos visores (2D y 3D)
		let parse = new ParseProjectVersion();
		this.projectData.valoresCentrado = parse.computeCenter(this.projectData);

		
		// Si tenemos valores de centrado, aplicamos la transformación que centra el schema en ese punto.
		// Sino, aplicamos la transformación por defecto (punto ( -10000, -10000 )) 
		let bCond1 = ( this.projectData && this.projectData?.scheme && 
					  this.projectData?.scheme?.x && this.projectData?.scheme?.y );
		let bCond2 = ( this.projectData.valoresCentrado ? this.projectData.valoresCentrado.applyDefault: true);

		let _x = 0;
		let _y = 0;
		
		if( bCond1 && !bCond2 ) {
			// Transformación que centra el schema2D en medio de la BoundaryBox que engloba todos los 
			// perímetros del proyecto
			_x = (window.innerWidth / 2) - Math.ceil(this.projectData.valoresCentrado.placement2D.margeX);
			_y = (window.innerHeight / 2) - Math.ceil(this.projectData.valoresCentrado.placement2D.margeY);
		} else {
			// Transformación por defecto (punto (-10000, -10000))
			_x = -((this.SVGWidth / 2) - (window.innerWidth / 2));
			_y = -((this.SVGWidth / 2) - (window.innerHeight / 2));
		}

		this.projectData.scheme.x = _x;
		this.projectData.scheme.y = _y;
		
		const value = 'translate(' + _x + ',' + _y + ') scale(1, 1)';
		this.renderer.setAttribute(this.PlaneSVG.nativeElement, 'transform', value);

		// Forzamos Reescalado (si hay perímetros, el centro del schema se habrá desplazado, 
		// por lo que es necesario ajustar el tamaño y posición de los iconos de puertas para que no se
		// desplacen y dejen de estar sobre las lineas del perímetro)
		this.reescalarSVG();
		

		//console.log('>>>>>>>>>>>>>>>>>>>>> updateFromParent()');
		//console.log(JSON.stringify(this.projectData.scheme));

		setTimeout(() => {
			this.dibujarProyecto();				// Actualizar el esquema.
			this.onChangeLengthPerimeters();	// Actualizar la longitud del perímetro.
			this.onZoomChange();					// Actualiza zoom.
			this.onUsuarioSeleccionado('DRAG');
			this.activateCursor(this.CURSOR.POINTER);
		}, 100);
	}

	// Después de crear la vista.
	ngAfterContentInit(): void {
		// console.log('-------------------- ngAfterContentInit()');
		// Obtener el objeto HTML para indicar la distancia desde el último poste colcado haste el cursor.
		this.HTMLNumberNew = document.getElementById('NumberNew');

		// Se levanta el dedo o se deja de mantener el botón del mouse.
		this.renderer.listen(this.PlaneSVG.nativeElement, 'mouseup', (event) => this.mouseUpGrid(event));
		this.renderer.listen(this.PlaneSVG.nativeElement, 'touchend', (event) => this.touchUpGrid(event));

		// Se toca con el dedo o se pulsa un botón del mouse.
		this.renderer.listen(this.PlaneSVG.nativeElement, 'mousedown', (event) => this.mouseDownGrid(event));
		this.renderer.listen(this.PlaneSVG.nativeElement, 'touchstart', (event) => this.touchStartGrid(event));

		// Se mueve el dedo sin levantarlo o el mouse sin dejar de presionar el botón.
		this.renderer.listen(this.PlaneSVG.nativeElement, 'mousemove', (event) => this.mouseMoveGrid(event));
		this.renderer.listen(this.PlaneSVG.nativeElement, 'touchmove', (event) => this.touchMoveGrid(event));

		// Se Cancela drag&drop
		this.renderer.listen(this.PlaneSVG.nativeElement, 'touchcancel', (event) => this.touchUpGrid(event));

		// Evento de la rueda del mouse.
		this.renderer.listen(this.PlaneSVG.nativeElement, this.navigatorScroll, (event) => this.mouseWheelGrid(event));

		// Toque en la pantalla o click con el mouse.
		this.renderer.listen(this.PlaneSVG.nativeElement, 'click', this.isPC ? (event) => this.clickGrid(event) : (event) => this.touchGrid(event));

		this.SVGSelector = 'hidden'; // ?????

		// Ajustar el actual zoom.
		this.adjustZoom = this.scale.incrementZoom * (this.SVGWidth / 2);

		// Calculamos el centro de los dos visores (2D y 3D)
		let parse = new ParseProjectVersion();
		this.projectData.valoresCentrado = parse.computeCenter(this.projectData);


		let _x = 0;
		let _y = 0;

		// Aplicamos la transformación par centrar el schema en el punto central de la BoundaryBox que enmarca todos los perímetros.
		_x = (window.innerWidth / 2) - Math.ceil(this.projectData.valoresCentrado.placement2D.margeX);
		_y = (window.innerHeight / 2) - Math.ceil(this.projectData.valoresCentrado.placement2D.margeY);	
		
		if (!this.projectData.scheme) this.projectData.scheme = new ProjectDataScheme();

		this.projectData.scheme.x = _x;
		this.projectData.scheme.y = _y;
		
		const value = 'translate(' + _x + ',' + _y + ') scale(1, 1)';
		this.renderer.setAttribute(this.PlaneSVG.nativeElement, 'transform', value);

		// this.renderGridMove(this.x, this.y);

		// Evitar el scroll.
		interact('.draggable').draggable({}).styleCursor(false);

		// Esperar un tiempo antes de empezar a actualizar.
		setTimeout(() => {
			this.dibujarProyecto();					// Actualiza esquema.
			this.onChangeLengthPerimeters();		// Actualiza longitud del perímetro.
			this.onZoomChange();					// Actualiza zoom.
			this.historialService.addHistorial(this.projectData);	// Almacena en el historial el proyecto.
			this.onUsuarioSeleccionado('DRAG');
			this.activateCursor(this.CURSOR.POINTER);
		}, 300);
		this.onUsuarioSeleccionado('DRAG');
		this.activateCursor(this.CURSOR.POINTER);
	}
	//#endregion

	//#region ################### Métodos de los @Output.
	//FIXME Aviso de que cambia de 2D a 3D y viceversa.
	onChange3Dto2D() {
		this.change3Dto2D.emit();
	}

	// Hace la petición de cambiar algún botón del ToolBar.
	onUsuarioSeleccionado(valor: string) { this.actualizarToolBar.emit(valor); }

	// Comunica al padre que se ha seleccionado un perímetro.
	onSelectPerimeter(index: number) {
		if (this.projectData.estado === 0) {
			this.INDEXPerimeterSelected = index;
			this.INDEXElevationSelected = Scheme2Component.NOT_PERIMETER;
			this.perimeterSelected = this.projectData.perimetro[index];
			this.selectPerimeter.emit(index);
			this.changeStyle(this.perimeterSelected);
		}
	}

	// Comunica al padre que se ha cambiado el zoom.
	onZoomChange() { this.zoomChange.emit(); }

	// Comunica que cambia la longitud del perímetro.
	onChangeLengthPerimeters() {
		this.totalLengthPerimeters = 0;
		this.projectData.perimetro.forEach(item => {
			if (item.longitud) this.totalLengthPerimeters += item.longitud;
		});
		this.totalLengthPerimetersStr = Utils.formatDecimal(this.totalLengthPerimeters.toString());
		this.changeLengthPerimeters.emit({ longitud: this.totalLengthPerimeters, longitudStr: this.totalLengthPerimetersStr });
	}
	//#endregion

	//#region #################### Métodos públicos.
	// Devuelve la actual unidad de medida, depende del zoom.
	public getUnit(): number { return this.unit; }

	// Devuelve la actual longitud del perímetro.
	public getTotalLengthPerimeters(): number { return this.totalLengthPerimeters; }
	//#endregion

	//#region #################### Eventos toolbar.
	// Poner en modo edición, crea un nuevo perímetro.
	public setDrawingMode(forzar = false): boolean {
		// Solo se puede editar si es borrador.
		if (this.projectData.estado !== 0) return;

		// Si  se fuerza no importa que esté en estado ESTADO_NEW.
		if (!forzar) {
			// Solo si es borrador y no está ya en ESTADO_NEW.
			if (this.state === this.ESTADO_NEW) return false;
		}

		// Prepara para nuevo perímetro.
		this.state = this.ESTADO_NEW;		// Asignar estado new.
		this.INDEXPerimeterNew = -2;		// Iniciar nuevo perimetro.
		this.INDEXPerimeterSelected = Scheme2Component.NOT_PERIMETER;	// Limpiar perímetro seleccionado.
		this.INDEXElevationSelected = Scheme2Component.NOT_PERIMETER;	// Limpiar elevación (escalón) seleccionado.
		this.changeStyles();				// Actualiza los css.
		return true;
	}

	// Si está en modo Drag se puede seleccionar un perímtro existente.
	public setSelected(): boolean {
		// Solo si es borrador.
		if (this.projectData.estado !== 0) return false;

		// prepara para seleeción.
		this.state = this.ESTADO_SELECT;		// Asignar estado select.
		this.INDEXPerimeterNew = Scheme2Component.NOT_PERIMETER;			// Iniciar que no es perímetro nuevo.
		this.INDEXPerimeterSelected = Scheme2Component.NOT_PERIMETER;		// Limpiar perímetro seleccionado.
		this.INDEXElevationSelected = Scheme2Component.NOT_PERIMETER;		// Limpiar elevación (escalón) seleccionado.
		this.changeStyles();					// Actualiza los css.
		return true;
	}

	// Asienta el modo drag.
	public setDragMode(forzar = false): boolean {
		// Limpia el número de distancia entre el último poste y el cursor.
		this.HTMLNumberNew.innerText = '';

		// Solo si es borrador.
		if (this.projectData.estado !== 0) return false;

		// Si está en ESTADO_NEW comprobar si hay más de un punto base.
		if (!forzar && this.state === this.ESTADO_NEW) {
			let p = this.projectData.perimetro[this.projectData.perimetro.length - 1]; // Nuevo perímetro.
			if (p.coordenadas.length < 2) { // Si solo hay un punto base eliminar el nuevo perímetro.
				// Si es el único perímetro, NO permitir que pase a ESTADO_DRAG, no tiene sentido si no tiene perímetros.
				if (this.projectData.perimetro.length < 2) return false;

				// Eliminar el último perímetro para evitar perímetros de un solo poste.
				this.INDEXPerimeterSelected = Scheme2Component.NOT_PERIMETER;
				this.projectData.perimetro.pop();
			}
			else {
				// Dejar selecionado el último perímetro solo si viene de NEW y se ha creado uno nuevo.
				if (this.INDEXPerimeterNew !== -2) this.INDEXPerimeterSelected = this.projectData.perimetro.length - 1;

				// prepara para Drag.
				this.INDEXPerimeterNew = Scheme2Component.NOT_PERIMETER;			// Iniciar que no es perímetro nuevo.
				this.INDEXElevationSelected = Scheme2Component.NOT_PERIMETER;		// Limpiar elevación (escalón) seleccionado.
				this.state = this.ESTADO_DRAG;			// Asignar estado drag.
				this.onSelectPerimeter(this.INDEXPerimeterSelected);	// Comunicar que se ha seleccionado un perímetro.
				this.changeStyles();					// Actualiza los css.
				return true;
			}
		}

		// Poner en ESTADO_DRAG
		this.INDEXPerimeterNew = Scheme2Component.NOT_PERIMETER;			// Iniciar que no es perímetro nuevo.
		this.INDEXElevationSelected = Scheme2Component.NOT_PERIMETER;		// Limpiar elevación (escalón) seleccionado.

		// Si está en estado door o stair, actualizar.
		if (this.state !== this.ESTADO_DOOR && this.state !== this.ESTADO_ELEVATION) {
			this.state = this.ESTADO_DRAG;		// Asignar estado drag.
			this.INDEXPerimeterSelected = Scheme2Component.NOT_PERIMETER;	// Limpiar perímetro seleccionado.
			this.changeStyles();				// Actualiza los css.
			return true;
		}
		this.state = this.ESTADO_DRAG;			// Asignar estado drag.
		return true;
	}

	public screenshotData: { dots: { x1, x2, y1, y2 }[] }[] = [];
	public actualizarScreenshot() {
		this.screenshotData = [];
		let minTop = 99999;
		let minLeft = 99999;
		let maxRight = 0;
		let maxBottom = 0;
		for (let p of this.projectData.perimetro) {
			let aux = [];
			for (let d of p.dotsBreak) {
				if (d.x1 < minLeft) minLeft = d.x1;
				if (d.y1 < minTop) minTop = d.y1;
				if (d.x1 > maxRight) maxRight = d.x1;
				if (d.y1 > maxBottom) maxBottom = d.y1;
				aux.push({
					x1: d.x1,
					x2: d.x2,
					y1: d.y1,
					y2: d.y2
				});
			}
			this.screenshotData.push({ dots: aux });
		};

		
		this.SVGheight = (maxBottom - minTop) + 20;
		this.SVGwidth = (maxRight - minLeft) + 20;

		for (let s of this.screenshotData) {
			for (let d of s.dots) {
				d.x1 = Math.abs(d.x1 - minLeft) + 10;
				d.x2 = Math.abs(d.x2 - minLeft) + 10;
				d.y1 = Math.abs(d.y1 - minTop) + 10;
				d.y2 = Math.abs(d.y2 - minTop) + 10;
			}
		}
	}

	// Asentar modo door (puerta).
	public setDoorMode(): boolean {
		// Debe existir proyecto y tener un perímetro seleccionado.
		if (!this.projectData && this.INDEXPerimeterSelected == Scheme2Component.NOT_PERIMETER) return false;

		// Colocar en estado Door.
		this.state = this.ESTADO_DOOR;
		return true;
	}
	// Asentar en modo elevation (escalón).
	public setElevationMode(): boolean {
		// Debe existir proyecto y tener un perímetro seleccionado.
		if (!this.projectData && this.INDEXPerimeterSelected == Scheme2Component.NOT_PERIMETER) return false;
		// Colocar en estado Elevation = this.ESTADO_ELEVACION = 4 inicializado
		this.state = this.ESTADO_ELEVATION; 
		return true;
	}

	// asentar en modo erase (borrador).
	public setEraseMode(): boolean {
		// Si ya está en estado de borrado o en estado de nuevo ignorar.
		if (this.state === this.ESTADO_ERASE || this.state === this.ESTADO_NEW) return false;

		this.state = this.ESTADO_ERASE;		// Asignar estado.
		return true;
	}

	/* 0 es igual a resetar los dos, 1 es goma y 2 es draw */
	public activateCursor(cursor: number) {
		this.cursorGoma = (cursor === this.CURSOR.ERASE);
		this.cursorDraw = (cursor === this.CURSOR.DRAW);
	}
	//#endregion

	//#region #################### Eventos touch.
	// Se inicia un toque en la pantalla.
	touchStartGrid(event: any) {
		// Almacenar las coordenadas.
		this.touchX = event.touches[0].clientX;
		this.touchY = event.touches[0].clientY;
		// Actualizar la grid.
		this.startGrid(this.touchX, this.touchY, event.touches[0].target, event.timeStamp);
	}

	// Mover la grid mientras se mantiene la presión en la pantalla.
	touchMoveGrid(event: any) {
		// Evitar la propagación del evento para tener el cotnrol total.
		event.stopPropagation();
		if (event.cancelable) {
			event.preventDefault();
		}

		// Obtener solo el primer dedo.
		let t = event.touches[0];
        this.moveGrid(t.clientX - this.touchX, t.clientY - this.touchY, event.touches[0].target);
		// this.x = t.clientX-this.touchX;
		// this.y = t.clientY-this.touchY;
		// sessionStorage.setItem('coordenadas',JSON.stringify({x:this.x, y:this.y}));
		// // Mover la grid de relativamente.
		// this.moveGrid(this.x ,this.y, event.touches[0].target);

		// Almacenar la actual coordenada.
		this.touchX = t.clientX;
		this.touchY = t.clientY;
	}

	// Se libera el touch.
	touchUpGrid(event: any) { this.upGrid(event); }

	// Un toque en la pantalla similar al click del mouse.
	touchGrid(event: any) {
		// Solo proyecto borrador.
		if (this.projectData.estado !== 0) return;

		// Distribuidor según estado.
		if (this.state === this.ESTADO_NEW) this._clickESTADO_NEW(event);
		else if (this.state === this.ESTADO_DRAG) this._clickESTADO_DRAG(event);
		else if (this.state === this.ESTADO_SELECT) this._clickESTADO_SELECT(event);
		else if (this.state === this.ESTADO_DOOR) this._clickESTADO_DOOR(event);
		else if (this.state === this.ESTADO_ELEVATION) this._clickELEVATION(event);
		else if (this.state === this.ESTADO_ERASE) this._clickESTADO_ERASE(event);
	}
	//#endregion

	//#region #################### Eventos del mouse.
	// Click.
	clickGrid(event: any) {
		// Solo proyecto borrador.
		if (this.projectData.estado !== 0) return;

		// Distribuidor según estado.
		if ((event.timeStamp - this.intervalMouseClick) > 60) { // Dar un tiempo entre clicks.
			if (this.state === this.ESTADO_NEW) this._clickESTADO_NEW(event);
			else if (this.state === this.ESTADO_DRAG) this._clickESTADO_DRAG(event);
			else if (this.state === this.ESTADO_SELECT) this._clickESTADO_SELECT(event);
			else if (this.state === this.ESTADO_DOOR) this._clickESTADO_DOOR(event);
			else if (this.state === this.ESTADO_ELEVATION) this._clickELEVATION(event);
			else if (this.state === this.ESTADO_ERASE) this._clickESTADO_ERASE(event);
		}
	}

	// El mouse empieza a tocar el elemento.
	mouseEnter(event: any) {
		//console.log(event.target.id);
		if (this.state === this.ESTADO_NEW) return;

		// Adquirir el id del objeto.
		let id = event.target.id;

		// Comproba que es un perímetro 'PR'.
		if (id.indexOf('PR') === 0) {
			this.INDEXPerimeterOver = parseInt(id.substr(2, 3));
			//console.log("this.INDEXPerimeterOver=" + this.INDEXPerimeterOver);	// Obtener el índice del perímetro.
			this.changeStyles();									// Actualiza css.
		}
	}

	// El mouse deja de tocar el elemento.
	mouseLeave(event: any) {
		//console.log(event.target.id);
		this.INDEXPerimeterOver = Scheme2Component.NOT_PERIMETER;		// Deseleccionar perímetros.
		this.changeStyles();				// Actualiza css.
	}

	// Evento click estando en estado Erase. Evento para borrar partes del perímetro, escalones, puertas
	private _clickESTADO_ERASE(event: any) {
		let id = event.target.id;			// Obtener identificador.
		let data = this.DATAIdDoor(id);		// Obtener puerta.
		if (data) { // Si es una puerta -> Borrar puerta.
			this.projectData.perimetro[data.perimeter].puertas.splice(data.door, 1);
			this.dibujarProyecto();									// Actualiza esquema.
			this.historialService.addHistorial(this.projectData);	// Actualizar historial.
			return;
		}

		// Si no es una puerta se comprueba si es una elevación.
		data = this.DATAIdElevation(id);		// Obtener identificador.
		if (data) { // Si es una elevación -> Borrar elevación.
			this.projectData.perimetro[data.perimeter].informacion.elevaciones.splice(data.elevation, 1);
			this.INDEXElevationSelected = Scheme2Component.NOT_PERIMETER;						// Deseleccionar elevación.
			this.dibujarProyecto();									// Actualiza esquema.
			this.historialService.addHistorial(this.projectData);	// Actualizar historial.
			return;
		}

		// Si no es una elevación comprobar si es un perímetro.
		if (id.indexOf('PR') === 0) { // Si es un perímetro -> Borrar perímetro.
			this.projectData.perimetro.splice(parseInt(id.substr(2, 3)), 1);
			localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData)); // Actializar localStorage.

			// Si no quedan perímetros pasar al estado new.
			if (this.projectData.perimetro.length === 0) {
				this.state = this.ESTADO_NEW;
				this.onUsuarioSeleccionado('NEW');
			}

			this.INDEXPerimeterSelected = -2;						// Deseleccionar perímetro.
			this.INDEXElevationSelected = Scheme2Component.NOT_PERIMETER;	// Deseleccionar elevación.
			this.dibujarProyecto();									// Actualiza esquema.
			this.historialService.addHistorial(this.projectData);	// Actualizar historial.
		}
	}

	// Evento click con estado door (puerta).
	private _clickESTADO_DOOR(event: any) {
		// Debe existir un perímetro seleccionado.
		if (this.INDEXPerimeterSelected === Scheme2Component.NOT_PERIMETER) return;

		// Debe seleccionar la línea de un perímetro.
		let dataLine = this.DATAIdLine(event.target.id);	// Obtener la línea.
		if (!dataLine) return;								// No es una línea.

		// Comprobar que es el perímetro seleccionado.
		if (this.INDEXPerimeterSelected !== dataLine.perimeter) return;	// No es el perímetro seleccionado.

		// Es una línea y es el perímetro seleccionado, obtener las coordenadas.
		let coor = this.projectData.perimetro[dataLine.perimeter].coordenadas;

		// Tamaño de la línea.
		let distancia = Utils.magnitud(coor[dataLine.line].lng, coor[dataLine.line].lat, coor[dataLine.line + 1].lng, coor[dataLine.line + 1].lat);

		// Convetir las coordenadas del mouse a coordenadas del perímetro (real no svg).
		let coorReal = this.mouseXYtoCoordenates(event);

		// Distancia desde el punto A al punto clicado en la línea.
		let margen = Utils.magnitud(coor[dataLine.line].lng, coor[dataLine.line].lat, coorReal.lng, coorReal.lat);
		let resto = distancia - margen;
		// Obtener el % desde punto A hasta el punto clicado.
		let tanto = parseFloat((100 - (resto / (distancia / 100))).toFixed(2));

		// Crear una puerta e insertarla.
		let puerta = new ProjectDataPuerta();
		puerta.lng = coorReal.lng;
		puerta.lat = coorReal.lat;
		puerta.lsp = dataLine.line;	// Número de la línea.
		puerta.margen = tanto;		// % desde el punto A, siempre manda el poste según flujo de creación.

		this.projectData.perimetro[dataLine.perimeter].puertas.push(puerta);	// Insertar la puerta.
		// Guardar el idSVG.
		puerta.idSVG = this.newIdDoor(dataLine.perimeter, dataLine.line, this.projectData.perimetro[dataLine.perimeter].puertas.length);

		// Actualizar el localStorage y el historial.
		localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));
		this.historialService.addHistorial(this.projectData);

		// Quitar el modo puertas, después de colocar una puerta se desactiva el modo, si se quiere colcar otra puerta se debe volver al modo door.
		this.setDragMode();					// activar modo drag.
		this.reescalarSVG();				// actualizamos escalados al insertar una puerta.
		this.dibujarProyecto();				// Actualiza esquema.
		this.onUsuarioSeleccionado('DRAG');	// Avisar al padre (canvas-renderer.component).

	}

	// Evento click con estado elevación.
	private _clickELEVATION(event: any) {
		// Debe existir un perímetro seleccionado.
		if (this.INDEXPerimeterSelected === Scheme2Component.NOT_PERIMETER) return;

		// Debe seleccionar la línea de un perímetro.
		let dataLine = this.DATAIdLine(event.target.id);	// Obtener la línea.
		if (!dataLine) return;								// No es una línea.

		// Comprobar que es el perímetro seleccionado.
		if (this.INDEXPerimeterSelected !== dataLine.perimeter) return;	// No es el perímetro seleccionado.

		// Es una línea y es el perímetro seleccionado, obtener las coordenadas.


		let coor = this.projectData.perimetro[dataLine.perimeter].coordenadas;
		// Tamaño de la línea.
		let distancia = Utils.magnitud(coor[dataLine.line].lng, coor[dataLine.line].lat, coor[dataLine.line + 1].lng, coor[dataLine.line + 1].lat);

		// Convetir las coordenadas del mouse a coordenadas del perímetro (real no svg).
		let coorReal = this.mouseXYtoCoordenates(event);


		// Distancia desde el punto A al punto clicado en la línea.
		let margen = Utils.magnitud(coor[dataLine.line].lng, coor[dataLine.line].lat, coorReal.lng, coorReal.lat);	
		let resto = distancia - margen;
		let tanto = parseFloat((100 - (resto / (distancia / 100))).toFixed(2));

		// El array elevaciones puede no existir, en caso de no existir crearlo.
		if (!this.projectData.perimetro[dataLine.perimeter].informacion.elevaciones)
			this.projectData.perimetro[dataLine.perimeter].informacion.elevaciones = [];
		// Crear la elevación.
		let elevacion = {
			idCercado: dataLine.perimeter,
			startDistance: tanto,
			fromPointZ: coorReal.lat,
			fromPointX: coorReal.lng,
			elevationValue: 0.2,
			lsp: dataLine.line,
			idSVG: ''
		};
		// insertar la elevación y actualizar el idSVG.
		this.projectData.perimetro[dataLine.perimeter].informacion.elevaciones.push(elevacion);
		elevacion.idSVG = this.newIdElevation(dataLine.perimeter, dataLine.line,
			this.projectData.perimetro[dataLine.perimeter].informacion.elevaciones.length-1);

		// Actualizar el localStorage e historial.
		localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));
		this.historialService.addHistorial(this.projectData);
		// console.log("VUELVO A LOCAL STORAGE");

		// Actualiza esquema.
		this.dibujarProyecto();
	}

	// Evento click con estado drag.
	private _clickESTADO_DRAG(event: any) {
		// Debe ser un perímetro.
		if (event.target.id.indexOf('PR') !== 0) return; // DESELECCIONAR???

		this.INDEXPerimeterOver = Scheme2Component.NOT_PERIMETER;											// Liberar el perímetro tocado.
		this.INDEXPerimeterSelected = parseInt(event.target.id.substr(2, 3));	// Asignar el índice del perímetro clickado.
		this.state = this.ESTADO_SELECT;										// Poner en estado select.
		this.onSelectPerimeter(this.INDEXPerimeterSelected);					// Comunicar al padre (canvas-renderer.component).
		this.changeStyles();													// Actualiza css.
	}

	// Evento click con estado select.
	private _clickESTADO_SELECT(event: any) {
		// Debe ser un perímetro.
		if (event.target.id.indexOf('PR') !== 0) return;

		this.INDEXPerimeterOver = Scheme2Component.NOT_PERIMETER;								// Liberar el perímetro tocado.
		let index = parseInt(event.target.id.substr(2, 3));			// Obtener el índice del perímetro tocado.

		//this.INDEXPerimeterOver = - 1;								// Liberar el perímetro tocado.

		// Si el perímetro clickado es distinto al perímetro seleccionado, ejecutar el cambio.
		if (index !== this.INDEXPerimeterSelected) {
			this.INDEXPerimeterSelected = index;					// Asignar el índice del perímetro clickado.
			this.onSelectPerimeter(this.INDEXPerimeterSelected);	// Comunicar al padre (canvas-renderer.component).
			this.changeStyles();									// Actualiza css.
		}
	}

	// Evento click con estado new.
	private _clickESTADO_NEW(event: any) {
		// Crear un nuevo perímetro si no está iniciado.
		if (this.INDEXPerimeterNew === -2 || this.INDEXPerimeterNew === Scheme2Component.NOT_PERIMETER) {
			this.INDEXPerimeterNew = this.projectData.perimetro.length;		// Obtener la cantidad de perímetros actuales.
			// Crear un nuevo perímetro.
			let nuevo = new ProjectDataPerimetro();

			// En caso de existir ya otros perímetros copiar la configuración de su predecesor.
			//if (this.indexPerimeterNew > 0) { -> viene de reajuste ¿?
			if (this.projectData.perimetro.length > 0) {
				// Hacer una copia del último proyecto.
				let aux = this.projectData.perimetro[this.INDEXPerimeterNew - 1];
				if (aux.producto) {	// Puede que no este configurado.
					nuevo.producto = JSON.parse(JSON.stringify(aux.producto));
				}
			}
			this.projectData.perimetro.push(nuevo);	// Insertar perímetro.
		}

		let coor = this.mouseXYtoCoordenates(event);									// Obtener las coordenadas.
		let coors = this.projectData.perimetro[this.INDEXPerimeterNew].coordenadas;		// Asignar las coordenas al nuevo perímetro.

		// Tener en cuenta si el nuevo punto es igual al anterior.
		// En caso afirmativo no ejecutar un nuevo punto.
		if (coors.length > 0) {
			let c = coors[coors.length-1];
			if (Utils.magnitud(c.lng, c.lat, coor.lng, coor.lat) < 0.01) return; // No sigue adelante.
		}

		// En caso de que el punto colocado sea igual al primer punto cerrar el perímetro pasando a estado drag.
		if (coors.length > 2) {	// Debe existir como mínimo dos puntos para crear un triangulo.
			let distancia = Utils.magnitud(coors[0].lng, coors[0].lat, coor.lng, coor.lat);
			// Si ambos puntos están lo suficientemente cerca se unen.
			if ((distancia * this.scaleRange) < (0.006 * this.scaleRange)) {
				coor.lng = coors[0].lng;
				coor.lat = coors[0].lat;
				// Finalizar el perímetro.
				this.setDragMode();
				this.onUsuarioSeleccionado('DRAG');
			}
		}

		// insertar las coordenadas.
		coors.push(coor);

		// Actualizar el localStorage e histroial
		localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));
		this.historialService.addHistorial(this.projectData);

		// Actualizar el esquema.
		this.dibujarProyecto();
	}

	// Eliminar todos los perímetros.
	public eraseAllPerimeters() {
		// TODO se debería avisar al usuario que va a eliminar todo.
		this.projectData.perimetro = [];			// Vaciar el array de perímetros.
		this.state = this.ESTADO_NEW;				// Activar el estado new.

		// Actualiza el localStorage e historial.
		localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));
		this.historialService.addHistorial(this.projectData);

		this.INDEXPerimeterNew = Scheme2Component.NOT_PERIMETER;		// Poner a nuevo perímetro.
		this.INDEXPerimeterSelected = Scheme2Component.NOT_PERIMETER;	// Liberar perímetro seleccionado.
		this.INDEXElevationSelected = Scheme2Component.NOT_PERIMETER;	// Liberar elevación seleccionada.

		this.dibujarProyecto;				// Actualizar el esquema.

		this.onUsuarioSeleccionado('NEW');	// Avisar al padre (canvas-renderer.component) de los cambios.
	}

	// _____ MOUSE_DOWN se pulsa el botón del mouse.
	mouseDownGrid(event: any) {
		if (event.buttons === 1) { // Solo botón izquierdo, ponde en iniciar grid.
			this.startGrid(event.movementX, event.movementY, event.target, event.timeStamp);
		}
	}

	// _____ MOUSE_UP se suelta el botón.
	mouseUpGrid(event: any) {
		this.HTMLNumberNew.innerText = '';	// Limpiar el número que indica la distancia entre le último poste y el cursor.
		this.upGrid(event);					// Liberar la grid.

		this.projectData.scheme = this.getTranslateScaleSVG();
		localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));
	}
	private getTranslateScaleSVG(): ProjectDataScheme {
		const plane = document.getElementById('idPlaneSVG');
		let result = new ProjectDataScheme();
		if (plane) {
			const transform = plane.getAttributeNS(null, 'transform');
			if (transform) {
				const datas = transform.replace(') ', ')#').split('#');
				for (let str of datas) {
					if (str.startsWith('scale')) {
						result.scale = parseFloat(str.replace('scale(', '').split(',')[0]);
					}
					else if (str.startsWith('translate')) {
						let nums = str.replace('translate(', '').replace(')', '').split(',');
						result.x = parseFloat(nums[0]);
						result.y = parseFloat(nums[1]);
					}
				}
			}
		}
		return result;
	}

	// _____ MOUSE_MOVE mover con del botón mantenido.
	mouseMoveGrid(event: any) {
		if (event.buttons === 1) { // Si es el botón izquierdo mover la grid.
			// this.x = event.movementX;
			// this.y =event.movementY;
			// sessionStorage.setItem('coordenadas',JSON.stringify({x:this.x, y:this.y}));
			// this.moveGrid(this.x, this.y, event.target);
			this.moveGrid(event.movementX, event.movementY, event.target);
		}
		else {
			if (this.state === this.ESTADO_NEW) {
				let num = '';		// Actualizar la distancia.
				if (this.INDEXPerimeterNew > Scheme2Component.NOT_PERIMETER) {
					let peri = this.projectData.perimetro[this.INDEXPerimeterNew];
					// Error cuando se pulsa historial, rectificamos el indice.
					if (!peri) {
						this.INDEXPerimeterNew = -1;
					}
					else {
						if (peri.coordenadas.length > 0) {
							let coor = peri.coordenadas[peri.coordenadas.length - 1];
							let ca = this.mouseXYtoCoordenates(event);
							num = (Utils.magnitud(ca.lng, ca.lat, coor.lng, coor.lat) * 100).toFixed(2);
						}
					}
				}
				this.HTMLNumberNew.innerText = num;
				// ¡¡¡ NO USAR offsetX, offsetY; FireFox devuelve siempre 0.
				this.HTMLNumberNew.style.left = event.layerX + 'px';
				this.HTMLNumberNew.style.top = (event.layerY - 25) + 'px';
			}
		}
	}

	// _____ MOUSE_WHEEL se rota la rueda del ratón.
	mouseWheelGrid(event: any) {
		//console.log(`mouseWheelGrid x::${event.x} y::${event.y} deltaY::${event.deltaY}`);
		if (event.deltaY > 0 && this.scaleRange < this.scale.maxZoom) {
			this.renderGridScale(event.x, event.y, this.scale.incrementZoom);
		} else if (event.deltaY < 0 && this.scaleRange > this.scale.minZoom) {
			this.renderGridScale(event.x, event.y, -this.scale.incrementZoom);
		}
		/*else {
			this.__testeo++;
			if (this.__testeo > 2) { this.__testeo = 2;	}
			else {
				// Usados para pasar a metros y reorientación de la Y.
				//this.currentScale = this.SCALES[this.__testeo].currentScale; // 1000; // 1000 / 100 / 10
				//this.AJUSTE_METROS_ORIENTACION_X = this.currentScale;
				//this.AJUSTE_METROS_ORIENTACION_Y = -this.currentScale;
				// Incremento del zo om. Actualmente es una constante ya que el editor no contempla su modificación.
				//this.INCREMENT_ZOO M = this.SCALES[this.__testeo].incrementZo om; //0.1;
				//this.scale.ma xZo om = this.SCALES[this.__testeo].max Zo om; //3;			// Máximo zo om permitido. 3
				//this.MIN_Z OOM = this.SCALES[this.__testeo].minZoo m; //0.5;		// Mínimo zo om permitido. 0.5
				this.scale = this.SCALES[this.__testeo];
				this.renderGridScale(event.x, event.y, -this.scale.incrementZo om);
			}
		}*/
	}

	// Ejecutar zoom en posición x,y.
	public zoom(x: number, y: number, moveAwake: boolean) {
		//console.log(`x::${x} y::${y} add::${moveAwake}`);
		if (moveAwake) {
			this.renderGridScale(0, 0, this.scale.incrementZoom);
		}
		else {
			this.renderGridScale(0, 0, -this.scale.incrementZoom);
		}
	}

	//#endregion

	//@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
	//@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
	//@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
	//@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@



	private dibujarProyecto() {
		// Comprobar si hay proyecto y si tiene perímetros.
		if (!this.projectData || !this.projectData.perimetro || this.projectData.perimetro.length === 0) return;

		for (let index = 0; index < this.projectData.perimetro.length; index++) {
			let pr = this.projectData.perimetro[index];
			// Comprobar si es el perímetro seleccionado.
			this.changeStyle(pr);

			// PR indica el número del perímetro que va de PR000 a PR999.
			pr.id = "PR" + ("00" + index.toString()).substr(-3);

			// Buble para sacar los postes base.
			pr.longitud = 0;
			pr.tramos = [];
			pr.tramos.push(0);
			for (let icoor = 0; icoor < pr.coordenadas.length; icoor++) {
				let co = pr.coordenadas[icoor];
				if (icoor + 1 < pr.coordenadas.length) {
					let co2 = pr.coordenadas[icoor + 1];
					//pr.longitud += Math.sqrt(Math.pow(co.lng - co2.lng, 2) + Math.pow(co.lat - co2.lat, 2)); // Magnitud.
					let metros = Utils.magnitud(co.lng, co.lat, co2.lng, co2.lat); // Magnitud.
					pr.longitud += metros;
					pr.tramos.push(parseFloat((metros * 100).toFixed(2)));
				}
				// Ajuste a la grid. Para guardar se debe ejecutar -> ((valor / AJUSTE_METROS_ORIENTACION) - AJUSTE_GRID) = coordenada.
				co.vx = this.PointToSVG_X(co.lng);
				co.vy = this.PointToSVG_Y(co.lat);
				// PR000P0000 el identificador está compuesto del id del perímetro + 'P0000', teniendo un total de 10000 postes por tramo.
				co.id = this.newIdPoint(index, icoor);
			}
			pr.longitud *= 100;

			// Romper líneas, puntos que están en la mitad de dos puntos base.
			// Si es movido rompe el tramo creando dos tramos y un nuevo poste base.
			//   Actua sobre el array de coordenadas.
			pr.dotsBreak = [];
			if (pr.coordenadas.length > 1) {
				for (let i = 0; i < pr.coordenadas.length - 1; i++) {
					pr.dotsBreak.push({
						dbx: ((pr.coordenadas[i].vx - pr.coordenadas[i + 1].vx) / 2) + pr.coordenadas[i + 1].vx,
						dby: ((pr.coordenadas[i].vy - pr.coordenadas[i + 1].vy) / 2) + pr.coordenadas[i + 1].vy,
						id: this.newIdBreak(index, i),
						lid: this.newIdLine(index, i),
						x1: pr.coordenadas[i].vx, y1: pr.coordenadas[i].vy,
						x2: pr.coordenadas[i + 1].vx, y2: pr.coordenadas[i + 1].vy
					});
				}
			}

			// Actualizar puertas.
			for (let i = 0; i < pr.puertas.length; i++) {
				pr.puertas[i].idSVG = this.newIdDoor(index, pr.puertas[i].lsp, i);
			}
			this.SVGUpdateDoorAll(index);

			// Actualizar elevaciones.
			if (!pr.informacion.elevaciones) {pr.informacion.elevaciones = [];
			}else {
				for (let i = 0; i < pr.informacion.elevaciones.length; i++) {
					// ID ->  PRpppELeellll p:Perímetro e:Elevación l:Línea.
					//pr.informacion.elevaciones[i].idSVG = pr.id + 'E L' + ('0' + i.toString()).substr(-2) + ('000' + pr.informacion.elevaciones[i].lsp).substr(-4);
					pr.informacion.elevaciones[i].idSVG = this.newIdElevation(index, pr.informacion.elevaciones[i].lsp, i);
				}
			}
			
			// index = le pasamos el perímetro que estamos utilizando / modificando
			this.SVGUpdateElevation(index);
		}
		localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));
		this.onChangeLengthPerimeters();
		// Poner en modo edición si está en estdo borrador, en caso contrario bloquear edición.
	}
	// ########################################################################################
	// Limpiar el layer de selección.
	clearSelector() { }

	public refresh(project: ProjectData) {
		this.projectData = project;
		this.SVGSelector = 'hidden';
		this.clearSelector();

		//this.adjustZoom = this.INCREMENT_ZOOM * (this.SVGWidth / 2);
		//this.render GridMove(-((this.SVGWidth / 2) - (window.innerWidth / 2)), -((this.SVGWidth / 2) - (window.innerHeight / 2)));

		if (!this.projectData.scheme) this.projectData.scheme = new ProjectDataScheme();

		this.dibujarProyecto();

		/*if (this.projectData.perimetro.length === 0) { this.setDrawingMode(true);	this.onUsuario Seleccionado('NEW');	}
		else {	this.setDragMode(true);	this.onUsuario Seleccionado('DRAG');	}*/
	}

	// Trabaja con this.projectData.s cheme => { x: -10000, y: -10000, scale: 1 }
	animateZoom() {
		//console.log(`this.scaleRange:: ${this.scaleRange}`);
		if (this.scaleRange === this.projectData.scheme.scale) {
			const value = 'translate(' + this.projectData.scheme.x + ',' + this.projectData.scheme.y + ') scale(' + this.scaleRange + ', '
				+ this.scaleRange + ')';
			//	console.log(value);
			this.renderer.setAttribute(this.PlaneSVG.nativeElement, 'transform', value);
			//this.render GridMove(this.projectData.s cheme.x, this.projectData.s cheme.y);
			// Dibujar la grid.
			//	this.render GridMove(-((this.SVGWidth / 2) - (window.innerWidth / 2)), -((this.SVGWidth / 2) - (window.innerHeight / 2)));
			return;
		};
		if (this.scaleRange < this.projectData.scheme.scale) {
			this.renderGridScale(0, 0, this.scale.incrementZoom, false);
		}
		
		if (this.scaleRange > this.projectData.scheme.scale) {
			this.renderGridScale(0, 0, -this.scale.incrementZoom, false);
		}

		//console.log(`this.scaleRange::${this.scaleRange} this.projectData.scheme.scale::${this.projectData.scheme.scale}`);

		this.animateZoom();
	}

	//función para saber en que posicion dentro de la grilla está el perímetro, si arrastramos, cambiamos la posición en el plano del perímetro
	renderGridMove(x: number, y: number) {

		// Obtener el ancho y alto de la vista cliente.
		const widthClient = window.innerWidth;
		const heightClient = window.innerHeight;
		// Si se mueve manda la nueva coordena X,Y.
		const width = this.SVGWidth * this.scaleRange;

		// Obtener las actuales coordenadas y sumar el desplazamiento.
		const m = this.PlaneSVG.nativeElement.getCTM();

		x = (m.e + x);
		y = (m.f + y);

		// Calcular los topes.
		let calcX = x + -widthClient;
		let calcY = y + -heightClient;

		if (calcX < -width) { // Se sale por la derecha.
			x = -(width - widthClient);
		} else if (x > 0) { // Se sale por la izquierda.
			x = 0;
		}

		if (calcY < -width) { // Se sale por abajo.
			y = -(width - heightClient);
		} else if (y > 0) { // Se sale por arriba.
			y = 0;
		}

		const value = 'translate(' + x + ',' + y + ') scale(' + this.scaleRange + ', ' + this.scaleRange + ')';
		this.renderer.setAttribute(this.PlaneSVG.nativeElement, 'transform', value);

		//Evento para recoger los datos de x,y scale del posicionamiento de la grilla y comunicarse con el padre ->canvas-renderer
		
		this.valoresGrilla = this.mueveGrid.emit([x,y,this.scaleRange]);

	}
	

	//FIXME working
	renderGridScale(x: number, y: number, deep: number, save = true) {
		const sc = this.scaleRange + deep;
		//console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> ' + sc);
		// Si la escala no está permitida, abortar.
		if (sc > this.scale.maxZoom || sc < this.scale.minZoom) return;

		// Obtener el ancho y alto de la vista cliente.
		const widthClient = window.innerWidth;
		const heightClient = window.innerHeight;

		// Aplicar la nueva escala.
		//		const oldScale = this.scaleRange;
		this.scaleRange = Math.round((this.scaleRange + deep) * 100) / 100;
		if (this.scaleRange > this.scale.maxZoom) { this.scaleRange = this.scale.maxZoom; }
		if (this.scaleRange < this.scale.minZoom) { this.scaleRange = this.scale.minZoom; }
		this.reescalarSVG();

		// Tamaño actual del panel SVG según la nueva escala.
		const widthHeight = this.SVGWidth * this.scaleRange;

		// Obtener la actual posición del panel SVG.
		const m = this.PlaneSVG.nativeElement.getCTM();
		let cx = m.e;
		let cy = m.f;

		// Comprobar si se sale de la zona de trabajo.
		const calcX = cx + -widthClient;
		const calcY = cy + -heightClient;

		let adjustZoomX = this.scale.incrementZoom * (this.SVGWidth / 2);
		let adjustZoomY = this.scale.incrementZoom * (this.SVGWidth / 2);

		if( this.projectData.valoresCentrado && !this.projectData.valoresCentrado.applyDefault ) {
			let xCenter = this.projectData.valoresCentrado.placement2D.margeX;
			let yCenter = this.projectData.valoresCentrado.placement2D.margeY;

			adjustZoomX = xCenter * this.scale.incrementZoom ;
			adjustZoomY = yCenter * this.scale.incrementZoom;
		}

		
		
		// Ajuste X (width)
		if (calcX < -widthHeight) { // Se sale por la derecha.
			cx = -(widthHeight - widthClient); 
		} 
		else {
			if (cx > 0) { 
				cx = 0; 
			} // Se sale por la izquierda.
			else { 
				cx += (deep > 0) ? -adjustZoomX : adjustZoomX; 
			}
		}
		if (cx > 0) { 
			cx = 0;
		}

		// Ajuste Y (height)
		if (calcY < -widthHeight) { 
			cy = -(widthHeight - heightClient); 
		} // Se sale por abajo.
		else {
			if (cy > 0) { 
				cy = 0; 
			} // Se sale por arriba.
			else { 
				cy += (deep > 0) ? -adjustZoomY : adjustZoomY; 
			}
		}
		if (cy > 0) { 
			cy = 0; 
		}

		const value = 'translate(' + cx + ',' + cy + ') scale(' + this.scaleRange + ', ' + this.scaleRange + ')';

		// Almacenar la última escala y posición.
		if (save === true && this.projectData.scheme) {
			this.projectData.scheme.scale = this.scaleRange;
			this.projectData.scheme.x = cx;
			this.projectData.scheme.y = cy;
			localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));
		}
		this.renderer.setAttribute(this.PlaneSVG.nativeElement, 'transform', value);
		//console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> FINISH renderer ZOOM');
		this.onZoomChange();
	}

	//#####################################################################
	// PANTALLA COMPLETA
	//#####################################################################
	public toggleFullscreen(activate: boolean) {

		const docEl = document.documentElement as HTMLElement & {
			mozRequestFullScreen(): Promise<void>;
			webkitRequestFullscreen(): Promise<void>;
			msRequestFullscreen(): Promise<void>;
		};

		const doc = document as Document & {
			mozCancelFullScreen(): Promise<void>;
			webkitExitFullscreen(): Promise<void>;
			msExitFullscreen(): Promise<void>;
		};

		if (activate) {
			if (docEl.requestFullscreen) {
				docEl.requestFullscreen();
			} else if (docEl.mozRequestFullScreen) { /* Firefox */
				docEl.mozRequestFullScreen();
			} else if (docEl.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
				docEl.webkitRequestFullscreen();
			} else if (docEl.msRequestFullscreen) { /* IE/Edge */
				docEl.msRequestFullscreen();
			}
		}
		else {
			if (doc.exitFullscreen) {
				doc.exitFullscreen();
			} else if (doc.mozCancelFullScreen) { /* Firefox */
				doc.mozCancelFullScreen();
			} else if (doc.webkitExitFullscreen) { /* Chrome, Safari and Opera */
				doc.webkitExitFullscreen();
			} else if (doc.msExitFullscreen) { /* IE/Edge */
				doc.msExitFullscreen();
			}

			this.scaleRange = 1;
		}

		/* if(activate && !document.fullscreenElement){ document.documentElement.requestFullscreen(); }
		 else if(!activate){ document.exitFullscreen(); }*/

	}

	// ##########################################################################################
	// ############################################################# General, para mouse y touch.
	// ##########################################################################################
	startGrid(x: number, y: number, target: any, timeStamp: number) {
		/******************************* */
		if (target.className.baseVal.indexOf('UIBreakEdit') > -1 || target.className.baseVal.indexOf('UIHaloBreakPoint') > -1) {
			// Objeto a arrastrar.
			this.objPressed = target;
			// Obtener las coordenadas.
			let coorX = (target.cx.baseVal.value + (x / this.scaleRange));
			let coorY = (target.cy.baseVal.value + (y / this.scaleRange));

			if (!this.isPC) {
				coorX = (target.cx.baseVal.value);
				coorY = (target.cy.baseVal.value);
			}
			// Crear el punto de división en el tramo.41
			
			this._divideSection(coorX, coorY);
			// Indicar que está arrastrando.
			//this.dragAndDrop = true;
			return;
		}
		/*************************************************** */
		this.touchstart = true;
		this.intervalMouseClick = timeStamp;
		this.objMoved = false;
		if (this.state !== this.ESTADO_NEW) {
			if (target.className.baseVal.indexOf('UIPointEdit') > -1 ||
				target.className.baseVal.indexOf('UIHaloPoint') > -1 || target.className.baseVal.indexOf('UIBreakEdit') > -1) {
				if (!this.isPC || ('ontouchstart' in window)) {
					//Activador de cruceta
					setTimeout(() => {
						if (!this.objMoved && this.touchstart) {
							this.activateCruceta = true;
							this.elementWithCrucetaId = target.id.substr(0, 10);
						}
					}, this.activateCrucetaDelay);
				}
				this.dragAndDrop = true;
				this.objPressed = target;
				return;
			}
		}

		this.objPressed = null;
		this.dragAndDrop = false;
	}

	showCrucetas(id: string): boolean {
		return (this.activateCruceta === true && this.elementWithCrucetaId === id);
	}

	showCrucetasCss(id: string, p: ProjectData): string {
		return (this.activateCruceta === true && this.elementWithCrucetaId === id) ? 'UIGrowPoint' : this.CSSPoint(p);
	}

	moveGrid(x: number, y: number, target: any) {
		this.touchstart = false;

		if (this.state !== this.ESTADO_NEW) {
			// ######### Modo edición.
			if (this.dragAndDrop) {
				//if (this.breaking) return; // Si está en proceso de dividir tramo, evitar movimientos.
				// Obtener las nuevas coordenadas.
				let coorX = (this.objPressed.cx.baseVal.value + (x / this.scaleRange));
				let coorY = (this.objPressed.cy.baseVal.value + (y / this.scaleRange));
				let pr = this.projectData.perimetro[parseInt(target.id.substr(2, 3))];
				if (pr) {
					pr.tramos = [0];
					for (let i = 0; i < pr.coordenadas.length - 1; i++) {
						let num = (Utils.magnitud(pr.coordenadas[i].lng, pr.coordenadas[i].lat, pr.coordenadas[i + 1].lng, pr.coordenadas[i + 1].lat) * 100).toFixed(2);
						pr.tramos.push(parseFloat(num));
					}
				}
				// Tener en cuenta si se trata de un punto de ruptura.
				/*	if (this.objPressed.className.baseVal.indexOf('UIBreakEdit') > - 1) {
						this._divideSection(coorX, coorY);
						//return;
					}
					else {*/
				if (this.isPC) {
					this.UpdateDotLine(this.objPressed.getAttribute('id'), coorX, coorY);
					this.objMoved = true;
				}
				else {
					if (this.activateCruceta || this.objPressed.className.baseVal.indexOf('UIBreakEdit') > -1) {
						this.UpdateDotLine(this.objPressed.getAttribute('id'), coorX, coorY);
						this.objMoved = true;
					}
				}
				// }
			}
			else {
				this.renderGridMove(x, y);
			}
		}
		else {
			// ########## Modo no edición.
			if (target.className.baseVal === 'UIPoint') {
			} else {
				this.renderGridMove(x, y);
			}
		}
	}
	// Divide un tramo en dos, creando una nueva coordenada.
	// Tiene en cuenta las puertas y las elevaciones.
	_divideSection(coorX: number, coorY: number) {
		this.breaking = true;
		// Obtener los datos del Break. { id: string, idSVG: number, perimeter: number, break: number}
		let dt = this.DATAIdBreak(this.objPressed.getAttribute('id'));
		if (!dt) return;

		//let _id = this.objPressed.getAttribute('id');
		//_id = _id.substr(0, 11);
		//let indexPro = parseInt(_id.substr(2, 3)); // PR000B0000 -> indice perímetro.
		//let indexCoor = parseInt(_id.substr(-4)) + 1; // PR000B0000 -> indice nueva coordenada.

		//FIXME..........................................
		if (this.projectData.perimetro[dt.perimeter].tramos[dt.break + 1] <= 2) return;

		// Convertir las coordenadas al antiguo formato y crear e insertar la nueva coordenada.
		let coorXold = this.SVGToPoint_X(coorX);
		let coorYold = this.SVGToPoint_Y(coorY);

		// Insertar el nuevo punto.
		this.projectData.perimetro[dt.perimeter].coordenadas.splice(dt.break + 1, 0, { lat: coorYold, lng: coorXold });

		// MOVER INDICES PUERTAS
		let indexDoorsNew = dt.break; // indexCoor - 1;
		let aux = 0;
		for (let door of this.perimeterSelected.puertas) {
			aux++;
			if (door.lsp > indexDoorsNew) door.lsp++;
			else if (door.lsp === indexDoorsNew) {
				if (door.margen > 50) {
					door.margen = parseFloat(((door.margen - 50) * 2).toFixed(2));
					door.lsp++;
				}
				else {
					door.margen = parseFloat((door.margen * 2).toFixed(2));
				}
			}
		}

		// TODO MOVER INDICE ELEVACIÓN
		
		if (this.perimeterSelected.informacion.elevaciones) {
			aux = 0;
			for (let elevacion of this.perimeterSelected.informacion.elevaciones) {
				aux++;
				if (elevacion.lsp > indexDoorsNew){ 
					elevacion.lsp++;				
				}else if (elevacion.lsp === indexDoorsNew) {
					if (elevacion.startDistance > 50) {
						elevacion.startDistance = parseFloat(((elevacion.startDistance - 50) * 2).toFixed(2));
						elevacion.lsp++;
					}
					else {
						elevacion.startDistance = parseFloat((elevacion.startDistance * 2).toFixed(2));
					}
				}
			}
		}

		// Actualiza el proyecto a nivel SVG.
		this.dibujarProyecto();

		// Retardo para poseer la nueva coordenada.
		setTimeout(() => {
			let id = this.newIdPoint(dt.perimeter, dt.break + 1);
			this.objPressed = document.getElementById(id);
			this.breaking = false;
			this.historialService.addHistorial(this.projectData);
		}, 5);
	}

	public elevationUP(perimetro: number, elevacion: number) {
		let dato = this.projectData.perimetro[perimetro].informacion.elevaciones[elevacion].elevationValue + 0.2;
		//if (this.projectData.perimetro[perimetro].informacion.tieneMuro) { dato += (this.projectData.perimetro[perimetro].informacion.alturaMuro/100); }
		if (dato <= this.MAX_ALTURA_ESCALON) {
			this.projectData.perimetro[perimetro].informacion.elevaciones[elevacion].elevationValue = parseFloat(dato.toFixed(1));
			localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));
		}
	}

	public elevationDown(perimetro: number, elevacion: number) {
		let dato = this.projectData.perimetro[perimetro].informacion.elevaciones[elevacion].elevationValue - 0.2;
		//if (this.projectData.perimetro[perimetro].informacion.tieneMuro) { dato += (this.projectData.perimetro[perimetro].informacion.alturaMuro/100); }
		if (dato >= 0) {
			this.projectData.perimetro[perimetro].informacion.elevaciones[elevacion].elevationValue = parseFloat(dato.toFixed(1));
			localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));
		}
	}

	public showBtnElevation(perimetro: number, elevation: number) {
		return this.INDEXPerimeterSelected === perimetro && this.INDEXElevationSelected === elevation;
	}

	upGrid(event: any) {
		// Se ha dejado de arrastrar un objeto.
		if (this.objMoved) {
			// Tener en cuenta si el poste movido es un extremo y toca el extremo opuesto -> en este caso unirlos.
			let dataPoint = this.DATAIdPoint(this.objPressed.getAttribute('id'));
			// Solo tener en cuenta si son postes.
			if (dataPoint) {
				let coor = this.projectData.perimetro[dataPoint.perimeter].coordenadas; // Coordenadas del perímetro.
				let primero = this.newIdPoint(dataPoint.perimeter, 0); // SVG Id del primer punto.
				let idUltimo = coor.length - 1;// Índice del último punto.
				let ultimo = this.newIdPoint(dataPoint.perimeter, idUltimo);

				// Debe ser el primero o último.
				if (dataPoint.idSVGCLear === primero) { // #### El poste arratrado es el primer poste.
					// Comprobar si hay distancia.
					let distancia = Utils.magnitud(coor[0].lng, coor[0].lat, coor[idUltimo].lng, coor[idUltimo].lat);
					if ((distancia * this.scaleRange) < (0.006 * this.scaleRange)) {
						coor[0].lng = coor[idUltimo].lng;
						coor[0].lat = coor[idUltimo].lat;
						// Actualizar gráficos.
						this.dibujarProyecto();
					}
				}
				else if (dataPoint.idSVGCLear === ultimo) { // #### El poste arratrado es el primer último.
					// Comprobar si hay distancia.
					let distancia = Utils.magnitud(coor[0].lng, coor[0].lat, coor[idUltimo].lng, coor[idUltimo].lat);
					if ((distancia * this.scaleRange) < (0.006 * this.scaleRange)) {
						coor[idUltimo].lng = coor[0].lng;
						coor[idUltimo].lat = coor[0].lat;
						// Actualizar gráficos.
						this.dibujarProyecto();
						
					}
				}
			}
			this.historialService.addHistorial(this.projectData);
		}
		this.objMoved = false;
		this.dragAndDrop = false;
		this.objPressed = null;

		this.touchstart = false;
		this.activateCruceta = false;
		this.elementWithCrucetaId = null;
	}

	contextMenu(event: any) {
		event.preventDefault();
	}

	// ______________________________________________________________________________________
	// _______________________________________________________________________________ UTILES
	// Convierte el número en valor aceptable para el SVG.
	// value: valor que viene por norma general del array de coodenadas de project Data. Ej.- '0.1523'
	// Value se multiplica por 1000(x) o -1000(y los valores se guardarón con la y abajo), de esta forma el ejemplo queda 15.23.
	// Después se hace un ajuste de la grid.
	public PointToSVG_X(value: number): number { return (value * this.scale.ajustMetersOrientationX) + this.AJUSTE_GRID; }
	public PointToSVG_Y(value: number): number { return (value * this.scale.ajustMetersOrientationY) + this.AJUSTE_GRID; }

	// Ejecuta la acción inversa de convertPointToSVG, util para guardar los datos en project Data.
	private SVGToPoint_X(value: number): number { return (value - this.AJUSTE_GRID) / this.scale.ajustMetersOrientationX; }
	private SVGToPoint_Y(value: number): number { return (value - this.AJUSTE_GRID) / this.scale.ajustMetersOrientationY; }

	// ######################################################################################################### Crear IDs
	// PRnnnLInnnn (11) PR-> perimetro de 0 a 999, LI-> línea de 0 a 9999.
	private newIdLine(perimeter: number, line: number): string {
		return 'PR' + ('00' + perimeter.toString()).substr(-3) + 'LI' + ('000' + line.toString()).substr(-4);
	}

	// PRnnnELeellll (13) PR-> perimetro de 0 a 999, EL-> 'ee' elecavión de 0-99, 'llll' línea de 0 a 9999.
	private newIdElevation(perimeter: number, line: number, elevation: number): string {
		return 'PR' + ('00' + perimeter.toString()).substr(-3) +
			'EL' + ('0' + elevation.toString()).substr(-2) + ('000' + line.toString()).substr(-4);
	}

	// PRnnnPUuullll (13) PR-> perimetro de 0 a 999, PU -> 'uu' puerta de 0-99, 'llll' línea de 0 a 9999.
	private newIdDoor(perimeter: number, line: number, door: number): string {
		return 'PR' + ('00' + perimeter.toString()).substr(-3) +
			'PU' + ('0' + door.toString()).substr(-2) + ('000' + line.toString()).substr(-4);
	}

	// PRnnnBbbbb (10) PR-> perimetro de 0 a 999, B -> 'bbbb' punto de ruptura de 0 a 9999.
	private newIdBreak(perimeter: number, point: number): string {
		return 'PR' + ('00' + perimeter.toString()).substr(-3) + 'B' + ('000' + point.toString()).substr(-4);
	}

	// PRnnnPeeee (10) PR-> perimetro de 0 a 999, P -> 'eeee' poste de 0 a 9999.
	private newIdPoint(perimeter: number, point: number): string {
		return 'PR' + ('00' + perimeter.toString()).substr(-3) + 'P' + ('000' + point.toString()).substr(-4);
	}

	// #########################################################################################################

	// Partiendo del punto base actualiza los puntos de ruptura, tiene en cuenta si el perímetro está cerrado.
	private SVGUpdateBreak(idDot: string) {
		let dataPoint = this.DATAIdPoint(idDot);

		const coor = this.projectData.perimetro[dataPoint.perimeter].coordenadas;	// Obtener las coordenadas.
		let breaks = this.projectData.perimetro[dataPoint.perimeter].dotsBreak; // Obtener los puntos de ruptura.

		let b1 = dataPoint.point - 1; //
		let b2 = dataPoint.point;
		let dot1 = dataPoint.point - 1;
		let dot2 = dataPoint.point + 1;

		// Comprobar si el perímetro está cerrado (la primera coordenada es igual a la última).
		const closed = (coor[0].lng == coor[coor.length - 1].lng) && (coor[0].lat == coor[coor.length - 1].lat);

		// Calcular primer break. Tener en cuenta si es el primer punto base.
		if (!(!closed && dataPoint.point == 0)) { // Si no está cerrado
			if (dataPoint.point == 0) {
				b1 = breaks.length - 1;
				dot1 = coor.length - 2;
			}
			breaks[b1].dbx = ((coor[dataPoint.point].vx - coor[dot1].vx) / 2) + coor[dot1].vx;
			breaks[b1].dby = ((coor[dataPoint.point].vy - coor[dot1].vy) / 2) + coor[dot1].vy;
			breaks[b1].x2 = coor[dot1 + 1].vx;
			breaks[b1].y2 = coor[dot1 + 1].vy;
			// Break point.
			let b = document.getElementById(this.newIdBreak(dataPoint.perimeter, b1));
			b.setAttributeNS(null, 'cx', breaks[b1].dbx);
			b.setAttributeNS(null, 'cy', breaks[b1].dby);
			// Línea.
			let l = document.getElementById(this.newIdLine(dataPoint.perimeter, b1));
			b.setAttributeNS(null, 'x2', breaks[b1].x2);
			b.setAttributeNS(null, 'y2', breaks[b1].y2);
		}

		if (!(!closed && dataPoint.point == coor.length - 1)) {
			if (dataPoint.point == coor.length - 1) {
				b2 = 0;
				dot2 = 1;
			}
			breaks[b2].dbx = ((coor[dataPoint.point].vx - coor[dot2].vx) / 2) + coor[dot2].vx;
			breaks[b2].dby = ((coor[dataPoint.point].vy - coor[dot2].vy) / 2) + coor[dot2].vy;
			breaks[b2].x1 = coor[dot2 - 1].vx;
			breaks[b2].y1 = coor[dot2 - 1].vy;
			// Break point.
			let b = document.getElementById(this.newIdBreak(dataPoint.perimeter, dataPoint.point));
			b.setAttributeNS(null, 'cx', breaks[b2].dbx);
			b.setAttributeNS(null, 'cy', breaks[b2].dby);
			// Línea.
			b.setAttributeNS(null, 'x1', breaks[b2].x1);
			b.setAttributeNS(null, 'y1', breaks[b2].y1);
		}
	}

	// Ajuste de las puertas de un tramo partiendo de un punto.
	private SVGUpdateDoor(perimeter: number, dot: number) {
		// Si no hay puertas no recalcula.
		if (this.projectData.perimetro[perimeter].puertas.length === 0) return;

		// Acción selecciva.
		let init = 0;
		let end = this.projectData.perimetro[perimeter].puertas.length; // Todas las puertas.
		let coor = this.projectData.perimetro[perimeter].coordenadas;
		// Solo las puertas que existan en los tramos que se unen en el punto.
		if (dot > -1) {
			init = (dot > 0) ? dot - 1 : dot;
			end = (dot < coor.length - 1) ? dot + 1 : dot;
		}
		// Ajuste de las puertas.
		for (let door of this.projectData.perimetro[perimeter].puertas) {
			if (door.lsp >= init && door.lsp <= end) {
				let result = this.utilsBuilder.getXYByMargin(
					coor[door.lsp].lng, coor[door.lsp].lat,
					coor[door.lsp + 1].lng, coor[door.lsp + 1].lat, door.margen);
				door.lng = result.x;
				door.lat = result.y;
			}
		}
	}

	// Actualiza las puertas del perímetro.
	private SVGUpdateDoorAll(perimeter: number) {
		// Si no hay puertas no recalcula.
		if (this.projectData.perimetro[perimeter].puertas.length === 0) return;

		// Acción selecciva.
		let init = 0;
		let end = this.projectData.perimetro[perimeter].puertas.length; // Todas las puertas.
		let coor = this.projectData.perimetro[perimeter].coordenadas;
		// Ajuste de las puertas.
		for (let door of this.projectData.perimetro[perimeter].puertas) {
			let result = this.utilsBuilder.getXYByMargin(
				coor[door.lsp].lng, coor[door.lsp].lat,
				coor[door.lsp + 1].lng, coor[door.lsp + 1].lat, door.margen);
			door.lng = result.x;
			door.lat = result.y;
		}
	}


	private SVGUpdateElevation(perimeter: number, dot: number = -1) {
		// Si no hay escalones no recalcula.
		if (!this.projectData.perimetro[perimeter].informacion.elevaciones) return;
		if (this.projectData.perimetro[perimeter].informacion.elevaciones.length === 0) return;

		// Acción selectiva.
		let init = 0;
		let end = this.projectData.perimetro[perimeter].informacion.elevaciones.length; // Todos los escalones.

		let coor = this.projectData.perimetro[perimeter].coordenadas;
		// Solo los escalones que existan en los tramos que se unen en el punto.

		//dot = -1 siempre, está inicializado en -1. dot hace referencia al punto de control que modificamos dentro de un perímetro
		// init = 0 siempre
		//end = al numero de escalones que indicas al perímetro que tiene

		// Entra cuando se modifica el perímetro e indica el init 
		if (dot > -1) {
			init = (dot > 0) ? dot - 1 : dot;
			end = (dot < coor.length - 1) ? dot + 1 : dot;
		}

		// Ajuste de los escalones.

		for (let escalon of this.projectData.perimetro[perimeter].informacion.elevaciones) {
			//lsp indica el tramo en el que estamos ubicando el escalon
			// if (escalon.lsp >= init && escalon.lsp <= end) {   Modificamos este código debido a la petición del ticket ESPRRIVISA-19: si no ubicabas el end(numero de escalones en el perímetro)
			//y el escalon.lsp (tramo donde ubicamos la elevación) no coincidían el escalón se quedaba descolgado. Tenían que coincidir para posicionarse en el medio.
			// 	console.log("escalon.lsp     "+escalon.lsp);

				let result = this.utilsBuilder.getXYByMargin(
					coor[escalon.lsp].lng, coor[escalon.lsp].lat,
					coor[escalon.lsp + 1].lng, coor[escalon.lsp + 1].lat, escalon.startDistance);
					// console.log("RESULT.X    "+result.x)
					// console.log("RESULT.Y    "+result.y)
					// console.log("STARTDISTANCE")
					// console.log(escalon.startDistance)
					// console.log("LGN")
					// console.log(coor[escalon.lsp].lng);
					// console.log("LAT")
					// console.log(coor[escalon.lsp].lat);
				escalon.fromPointX = result.x; 
				escalon.fromPointZ = result.y;
			// }
		}
	}

	public selectElevation(perimeter: number, elevation: number) {
		if (perimeter === this.INDEXPerimeterSelected) {
			this.INDEXElevationSelected = (this.INDEXElevationSelected === elevation) ? Scheme2Component.NOT_PERIMETER : elevation;
		}
	}

	// Actualiza el punto SVG de una línea, lo almacena en project Data y guarda en storage.
	private UpdateDotLine(idDot: string, x: number, y: number) {
		let dataPoint = this.DATAIdPoint(idDot);
		if (!dataPoint) return;
		let coor = this.projectData.perimetro[dataPoint.perimeter].coordenadas[dataPoint.point];
		coor.vx = x;
		coor.vy = y;
		coor.lat = this.SVGToPoint_Y(y);
		coor.lng = this.SVGToPoint_X(x);
		//
		this.SVGUpdateBreak(idDot.substr(0, 10));

		this.SVGUpdateDoor(dataPoint.perimeter, dataPoint.point);

		//dataPoint.perimeter = nos indica si hay varios perímetros en el dibujo, nos indica que posición está (en función del orden que lo hemos dibujado),
		//el primero es 0, segundo que hemos dibujado 1,....ect

		console.log("DATAPOINT: "+ dataPoint.point);
		//dataPoint.point = son los puntos de control del perímetro, si en un perímetro hay 4 tramos el dataPoint.point 0 es el primer punto que se coloca el 1 el punto de en medio que hay entre el 
		//primer punto y el segundo, el punto 3 el que está en medio entre el punto 2 y 3. Si se va modificando, y amplía el punto de control, se modifican esos numeros porque varía el perímetro
		this.SVGUpdateElevation(dataPoint.perimeter, dataPoint.point);

		localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));

		// Actualizar la longitud.
		for (let p = 0; p < this.projectData.perimetro.length; p++) {
			if (p == dataPoint.perimeter) { // Computar el perímetro modificdo.
				let pr = this.projectData.perimetro[p];
				pr.longitud = 0;
				for (let c = 0; c < pr.coordenadas.length; c++) {
					if ((c + 1) < pr.coordenadas.length) {
						pr.longitud += Math.sqrt(Math.pow(pr.coordenadas[c].lng - pr.coordenadas[c + 1].lng, 2) + Math.pow(pr.coordenadas[c].lat - pr.coordenadas[c + 1].lat, 2));
					}
				}
				pr.longitud *= 100;
			}
		}
		this.onChangeLengthPerimeters();
	}

	public refreshLine(pdp: ProjectDataPerimetro) {
		if (!pdp.css) this.changeStyle(pdp);
		return pdp.css.SVGClassLine;
	}

	// Convierte la coordenadas del mouse a las reales (no svg).
	// Devuelve un objeto JSON { lat: 0, lng: 0 }
	private mouseXYtoCoordenates(event: any) {
		let x = event.clientX * this.unit;
		let y = event.clientY * this.unit;
		let svg = document.getElementById('idRectSVG');
		let d = svg.getBoundingClientRect();
		return {
			lat: this.SVGToPoint_Y(y - (d.top * this.unit)),
			lng: this.SVGToPoint_X(x - (d.left * this.unit))
		};
	}

	// _______________________________________________________________________________ UTILES
	// ______________________________________________________________________________________

	// Pregunta si el perímetro existe retorna true.
	private existsPerimeter(i: number, id: string): boolean {
		if (i < 0) return false;
		return (this.projectData.perimetro[i] && this.projectData.perimetro[i].id === id);
	}

	// Cambia los estilos css.
	public changeStyle(pdp: ProjectDataPerimetro) {
		if (!pdp) return;
		if (!this.projectData || !pdp.id) return false;

		if (this.existsPerimeter(this.INDEXPerimeterSelected, pdp.id)) {
			pdp.css = {
				SVGClassBreak: 'UIBreakEdit',
				SVGClassPoint: 'UIPointEdit',
				SVGClassLine: 'UIPerimeterEdit'
			};
		}
		else if (this.existsPerimeter(this.INDEXPerimeterNew, pdp.id)) {
			pdp.css = {
				SVGClassBreak: 'UIBreakNew',
				SVGClassPoint: 'UIPointNew',
				SVGClassLine: 'UIPerimeterNew'
			};
		}
		else if (this.existsPerimeter(this.INDEXPerimeterOver, pdp.id)) {
			pdp.css = {
				SVGClassBreak: 'UIBreakOver',
				SVGClassPoint: 'UIPointOver',
				SVGClassLine: 'UIPerimeterOver'
			};
		}
		else {
			pdp.css = {
				SVGClassBreak: 'UIBreak',
				SVGClassPoint: 'UIPoint',
				SVGClassLine: 'UIPerimeter'
			};
		}
	}

	// Cambia los estilos de todos los perímetros según el estado.
	public changeStyles() {
		if (!this.projectData) return;
		for (let index = 0; index < this.projectData.perimetro.length; index++) {
			this.changeStyle(this.projectData.perimetro[index]);
		}
	}

	public reescalarSVG() {

		// Tomamos como valor por defecto, el que usábamos hasta ahora (1)
		let scaleRange2 = this.scaleRange;

		// Si se ha calculado un nuevo punto de centrado, recalculamos la escala proporcional.
		//let bCondDefault =  ( this.projectData.valoresCentrado ? this.projectData.valoresCentrado.applyDefault: true);
		//if( this.projectData.valoresCentrado && !bCondDefault ) {
			let xCenter = this.projectData.valoresCentrado.placement2D.margeX;
			let yCenter = this.projectData.valoresCentrado.placement2D.margeY;

			// Para evitar dividir por cero, incrementamos ambas coordenadas un poco, 
			// para ser capaces de realizar la operación sin generar un error
			if( yCenter === 0 ) {
				xCenter += 0.01;
				yCenter += 0.01;
			}
			scaleRange2 = ( xCenter / yCenter );
		//}
 
		this.SVGLineGrid = 0.5 / this.scaleRange;
		this.SVGLineGrid10 = 1 / this.scaleRange;
		this.SVGLinePath = 3 / this.scaleRange;
		this.SVGStrongLinePath = 14 / this.scaleRange;
		this.SVGCirclePoint = 1 / this.scaleRange;
		this.SVGCircleRadio = 7 / this.scaleRange;
		this.SVGBreakRadio = 5 / this.scaleRange;
		this.SVGText = 12 / this.scaleRange;
		this.SVGTextSeparation = 12 / this.scaleRange;

		// Escalado de puerta, que mantiene el icono encima de la linea del perímetro
		this.SVGDoorY = Math.floor(24 / scaleRange2);
		
/* 		this.SVGEscalonY = Math.floor(24 / this.scaleRange);
		this.SVGEscalonX = this.SVGEscalonY / 2;
		this.SVGEscalon = this.SVGEscalonY + 'px'; */

		this.unit = 1 / this.scaleRange;
	}

	public setProjectData(projectData: ProjectData) {
		this.projectData = projectData;
	}

	// ############################################################# CSS
	//public SVGidLineStr(valor: string) { return valor + 'Line'; }
	public CSSPoint(p: any): string { return (p && p.css) ? p.css.SVGClassPoint : 'UIPoint'; }

	public CSSLine(p: any): string { return (p && p.css) ? p.css.SVGClassLine : 'UIPerimeter'; }

	public CSSBreak(p: any): string { return (p && p.css) ? p.css.SVGClassBreak : 'UIBreak'; }

	// ############################################################# HTML
	// Devuelve los metros entre dos puntos en formato string.
	// Si no es '0' vuelve ''.
	public HTMLMetros(iPr: number, iBr: number): string {
		let valor = '';
		if (!this.projectData) return '';
		if (!this.projectData.perimetro[iPr]) return '';
		if (this.projectData.perimetro[iPr].tramos && this.projectData.perimetro[iPr].tramos.length > 1) {
			valor = this.projectData.perimetro[iPr].tramos[iBr].toString();
		}
		return (valor === '0') ? '' : valor;
		
	}

	// ############################################################# DATA ID
	public DATAIdPoint(id: string): any {
		// PRnnnPeeee (10) PR-> perimetro de 0 a 999, P -> 'eeee' poste de 0 a 9999.
		if (!id.startsWith('PR') || !id.includes('P') || id.length < 10) return undefined;
		return {
			idSVG: id.substr(0, 5),
			idSVGCLear: id.substr(0, 10),
			perimeter: parseInt(id.substr(2, 3)),
			point: parseInt(id.substr(6, 4))
		};
	}

	public DATAIdLine(id: string): any {
		// PR123LI4567 (11) PR-> perimetro de 0 a 999, LI-> línea de 0 a 9999.
		if (!id.startsWith('PR') || !id.includes('LI') || id.length < 11) return undefined;
		return {
			idSVG: id.substr(0, 5),
			perimeter: parseInt(id.substr(2, 3)),
			line: parseInt(id.substr(7, 4))
		};
	}

	public DATAIdDoor(id: string): any {
		// PRnnnPUuullll (13) PR-> perimetro de 0 a 999, PU -> 'uu' puerta de 0-99, 'llll' línea de 0 a 9999.
		if (!id.startsWith('PR') || !id.includes('PU') || id.length < 13) return undefined;
		return {
			idSVG: id.substr(0, 5),
			perimeter: parseInt(id.substr(2, 3)),
			line: parseInt(id.substr(9, 4)),
			door: parseInt(id.substr(7, 2))
		};
	}

	public DATAIdBreak(id: string): any {
		// PRnnnBbbbb (10) PR-> perimetro de 0 a 999, B -> 'bbbb' punto de ruptura de 0 a 9999.
		if (!id || !id.startsWith('PR') || !id.includes('B') || id.length < 10) return undefined;
		return {
			id: id,
			idSVG: id.substr(0, 5),
			perimeter: parseInt(id.substr(2, 3)),
			break: parseInt(id.substr(6, 4)) // Es el punto A en el array de puntos base.
		};
	}

	public DATAIdElevation(id: string): any {
		// PRnnnELeellll (13) PR-> perimetro de 0 a 999, EL-> 'ee' elecavión de 0-99, 'llll' línea de 0 a 9999.
		if (!id.startsWith('PR') || !id.includes('EL') || id.length < 13) return undefined;
		return {
			idSVG: id.substr(0, 5),
			perimeter: parseInt(id.substr(2, 3)),
			line: parseInt(id.substr(9, 4)),
			elevation: parseInt(id.substr(7, 2))
		};
	}
}




//########################################################################
//########################################################################
//########################################################################
//########################################################################

//public SVGMetrosY(value: number): number { return value + 20; }
	// public getCSSPoint(p: any): string { return (p && p.css) ? p.css.SVGClassPoint : 'UIPoint'; }
	// public getCSSLine(p: any): string { return (p && p.css) ? p.css.SVGClassLine : 'UIPerimeter'; }
	// public getCSSBreak(p: any): string { return (p && p.css) ? p.css.SVGClassBreak : 'UIBreak'; }
		// Indice del perímetro que ha sido seleccionado.
	// Ocurre cuando se pasa de ESTADO_DRAG a ESTADO_SELECT
	//public index PerimeterSelected = - 1;
	// Pregunta si el perímetro existe retorna true.
	// private existsPerimeter(i: number, id: string): boolean {
	// 	if (!this.projectData || i < 0 || !id) return false;
	// 	if (i < 0) return false;
	// 	return (this.projectData.perimetro[i] && this.projectData.perimetro[i].id === id);
	// }
		//private changeStyle(pdp: ProjectDataPerimetro) { this.changeStyle(pdp);	}
			// Grupo SVG con todos los perímetros. ACTUALMENTE SIN USO.
	//@ViewChild('PerimetrosSVG', { static: true }) PerimetrosSVG: ElementRef;
	//#endregion
		// Nuevo perímetro (solo en ESTADO_NEW). private indexPerimeterNew = - 1; // No tiene perímetro asignado.

	// Indice del perímetro sobre el que se pasa el ratón. private indexPerimetroOver = - 1;	// No toca perímetro.
		// Elevación seleccionada. private indexElevationSelected = - 1;	// No tiene elevación (escalón) asignado.

	// // Cambia los estilos según el estado.
	// private changeStyles() {
	// 	for (let index = 0; index < this.projectData.perimetro.length; index++) {
	// 		this.changeStyle(this.projectData.perimetro[index]);
	// 	}
	// }

	// ######################################################################################################### Leer IDs
	// private datasIdLine(id: string): any {
	// 	// PR123LI4567 (11) PR-> perimetro de 0 a 999, LI-> línea de 0 a 9999.
	// 	if (!id.startsWith('PR') || !id.includes('LI') || id.length < 11) return undefined;
	// 	return {
	// 		idSVG: id.substr(0, 5),
	// 		perimeter: parseInt(id.substr(2, 3)),
	// 		line: parseInt(id.substr(7, 4))
	// 	};
	// }
	// private dataIdElevation(id: string): any {
	// 	// PRnnnELeellll (13) PR-> perimetro de 0 a 999, EL-> 'ee' elecavión de 0-99, 'llll' línea de 0 a 9999.
	// 	if (!id.startsWith('PR') || !id.includes('EL') || id.length < 13) return undefined;
	// 	return {
	// 		idSVG: id.substr(0, 5),
	// 		perimeter: parseInt(id.substr(2, 3)),
	// 		line: parseInt(id.substr(9, 4)),
	// 		elevation: parseInt(id.substr(7, 2))
	// 	};
	// }

		// private dataIdDoor(id: string): any {
	// 	// PRnnnPUuullll (13) PR-> perimetro de 0 a 999, PU -> 'uu' puerta de 0-99, 'llll' línea de 0 a 9999.
	// 	if (!id.startsWith('PR') || !id.includes('PU') || id.length < 13) return undefined;
	// 	return {
	// 		idSVG: id.substr(0, 5),
	// 		perimeter: parseInt(id.substr(2, 3)),
	// 		line: parseInt(id.substr(9, 4)),
	// 		door: parseInt(id.substr(7, 2))
	// 	};
	// }

	// private dataIdBreak(id: string): any {
	// 	// PRnnnBbbbb (10) PR-> perimetro de 0 a 999, B -> 'bbbb' punto de ruptura de 0 a 9999.
	// 	if (!id.startsWith('PR') || !id.includes('B') || id.length < 10) return undefined;
	// 	return {
	// 		idSVG: id.substr(0, 5),
	// 		perimeter: parseInt(id.substr(2, 3)),
	// 		break: parseInt(id.substr(6, 4))
	// 	};
	// }
		// private dataIdPoint(id: string): any {
	// 	// PRnnnPeeee (10) PR-> perimetro de 0 a 999, P -> 'eeee' poste de 0 a 9999.
	// 	if (!id.startsWith('PR') || !id.includes('P') || id.length < 10) return undefined;
	// 	return {
	// 		idSVG: id.substr(0, 5),
	// 		idSVGCLear: id.substr(0, 10),
	// 		perimeter: parseInt(id.substr(2, 3)),
	// 		point: parseInt(id.substr(6, 4))
	// 	};
	// }